import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
import './App.css';

// 组件导入
import Header from './components/Header';
import Footer from './components/Footer';

// 页面导入
import Home from './pages/Home';
import Archive from './pages/Archive';
import WritePost from './pages/WritePost';
import About from './pages/About';
import Auth from './pages/Auth';
import PostDetail from './pages/PostDetail';
import NotFound from './pages/NotFound';

const { Content } = Layout;

function App() {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState({
    name: 'zhou',
    bio: '这个人很神秘，什么也没留下。',
    email: 'zhou@gmail.com',
    techStack: '暂无',
    hobbies: '暂无',
    github: '#',
    homepage: '#',
    detail: '欢迎来到我的博客！请登陆后完善您的个人信息！'
  });

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    setUserInfo(prev => ({ ...prev, ...userData }));
    message.success('登录成功！');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    message.success('已退出登录');
  };

  const updateUserInfo = (newInfo) => {
    setUserInfo(prev => ({ ...prev, ...newInfo }));
    message.success('个人信息已更新');
  };

  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Layout className="app-layout">
          <Header isLoggedIn={isLoggedIn} onLogout={handleLogout} />
          <Content className="app-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/archive" element={<Archive />} />
              <Route path="/write" element={
                isLoggedIn ? <WritePost /> : <Navigate to="/auth" />
              } />
              <Route path="/about" element={
                <About 
                  userInfo={userInfo} 
                  isLoggedIn={isLoggedIn} 
                  onUpdate={updateUserInfo}
                />
              } />
              <Route path="/auth" element={
                <Auth onLogin={handleLogin} isLoggedIn={isLoggedIn} />
              } />
              <Route path="/post/:id" element={<PostDetail />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Content>
          <Footer />
        </Layout>
      </Router>
    </ConfigProvider>
  );
}

export default App;